module.exports = __webpack_public_path__ + "img/2.2be2ccf3.jpg";